import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkAuthLogin } from "../services/checkAuthApi";

export const useCheckAuthToken = () => {
  const [isAuth, setIsAuth] = useState(null);
  const [tokenAccessApi, setTokenAccessApi] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      const token_access_api = localStorage.getItem("token_jwt");
      setTokenAccessApi(token_access_api);
      const result_check_auth = await checkAuthLogin(token_access_api);
      if (!result_check_auth.page_is_auth) {
        localStorage.removeItem("token_jwt");
        navigate("/");
      } else {
        setIsAuth(result_check_auth.page_is_auth);
      }
    })();
  }, [navigate]);
  return {isAuth, tokenAccessApi};
};
